<form [formGroup]="distributorPickerForm">
    <select formControlName="distributorControl">
        @for (option of options(); track option.distributorId) {
            <option [ngValue]="option.distributorId">{{ option.distributorName }}</option>
        }
    </select>
</form>
